var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"prop":"labelName","label":"Label Name","width":"180"}}),_c('el-table-column',{attrs:{"prop":"labelCode","label":"Label Code","width":"250"}}),_c('el-table-column',{attrs:{"prop":"variable","label":"Variable"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }